import { render, staticRenderFns } from "./DashboardPanel.vue?vue&type=template&id=1f2785b4"
import script from "./DashboardPanel.vue?vue&type=script&lang=js"
export * from "./DashboardPanel.vue?vue&type=script&lang=js"
import style0 from "./DashboardPanel.vue?vue&type=style&index=0&id=1f2785b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports